import React from 'react'
import clsx from 'clsx'

import DesktopPageHeader from 'components/ResponsiveLayout/DesktopPageHeader'
import PageContainer from 'components/ResponsiveLayout/PageContainer'
import { PELATIHAN_MANDIRI_HELPDESK_LINK } from 'app/PelatihanMandiriPage/constants'

import type { BreadcrumbItemDef } from 'components/ResponsiveLayout/Breadcrumb'

type PelatihanDetailShellProps = {
  actions?: React.ReactNode
  breadcrumbs: BreadcrumbItemDef[]
  children: React.ReactNode
  className?: string
  contentClassName?: string
  mode?: 'split' | 'full'
  sidebar?: React.ReactNode
}

const PelatihanDetailShell = ({
  actions,
  breadcrumbs,
  children,
  className,
  contentClassName,
  mode = 'full',
  sidebar,
}: PelatihanDetailShellProps) => (
  <div className={clsx('min-h-screen bg-gray-10', className)}>
    <DesktopPageHeader
      breadcrumbItems={breadcrumbs}
      navLinks={[
        {
          label: 'Bantuan',
          href: PELATIHAN_MANDIRI_HELPDESK_LINK,
          external: true,
        },
      ]}
    />
    <PageContainer className="py-6">
      {actions ? (
        <div
          className={clsx(
            'mb-4 flex justify-end',
            mode === 'full' && 'mx-auto w-full max-w-4xl'
          )}
        >
          {actions}
        </div>
      ) : null}
      {mode === 'split' ? (
        <div className="grid items-start gap-6 lg:grid-cols-[minmax(320px,400px)_minmax(0,1fr)]">
          <aside className="sticky top-32 min-w-0">{sidebar}</aside>
          <main className={clsx('min-w-0', contentClassName)}>{children}</main>
        </div>
      ) : (
        <main className={clsx('mx-auto w-full max-w-4xl', contentClassName)}>
          {children}
        </main>
      )}
    </PageContainer>
  </div>
)

export default PelatihanDetailShell
